var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111470_19126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111470_19126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 86.9647,
    height: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.97656,
    cy: 4,
    r: 1,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.97656,
    cy: 4,
    r: 1,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9766,
    cy: 4,
    r: 1,
    fill: "#595959"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6943 11C26.6943 10.4477 27.1421 10 27.6943 10H81.0355C81.5878 10 82.0355 10.4477 82.0355 11V15C82.0355 15.5523 81.5878 16 81.0355 16H27.6943C27.1421 16 26.6943 15.5523 26.6943 15V11Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H23.7294V85H3C1.89543 85 1 84.1046 1 83V7Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 16C8.433 16 10 14.433 10 12.5C10 10.567 8.433 9 6.5 9C4.567 9 3 10.567 3 12.5C3 14.433 4.567 16 6.5 16Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C12 11.4477 12.4477 11 13 11H21C21.5523 11 22 11.4477 22 12V13C22 13.5523 21.5523 14 21 14H13C12.4477 14 12 13.5523 12 13V12Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 23C21.7295 22.4477 21.2818 22 20.7295 22H4.00008C3.44779 22 3.00008 22.4477 3.00008 23V23C3.00008 23.5523 3.44779 24 4.00008 24H20.7295C21.2818 24 21.7295 23.5523 21.7295 23V23Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 28C21.7295 27.4477 21.2818 27 20.7295 27H4.00008C3.44779 27 3.00008 27.4477 3.00008 28V28C3.00008 28.5523 3.44779 29 4.00008 29H20.7295C21.2818 29 21.7295 28.5523 21.7295 28V28Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 33C21.7295 32.4477 21.2818 32 20.7295 32H4.00008C3.44779 32 3.00008 32.4477 3.00008 33V33C3.00008 33.5523 3.44779 34 4.00008 34H20.7295C21.2818 34 21.7295 33.5523 21.7295 33V33Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 38C21.7295 37.4477 21.2818 37 20.7295 37H4.00008C3.44779 37 3.00008 37.4477 3.00008 38V38C3.00008 38.5523 3.44779 39 4.00008 39H20.7295C21.2818 39 21.7295 38.5523 21.7295 38V38Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 43C21.7295 42.4477 21.2818 42 20.7295 42H4.00008C3.44779 42 3.00008 42.4477 3.00008 43V43C3.00008 43.5523 3.44779 44 4.00008 44H20.7295C21.2818 44 21.7295 43.5523 21.7295 43V43Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 48C21.7295 47.4477 21.2818 47 20.7295 47H4.00008C3.44779 47 3.00008 47.4477 3.00008 48V48C3.00008 48.5523 3.44779 49 4.00008 49H20.7295C21.2818 49 21.7295 48.5523 21.7295 48V48Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 53C21.7295 52.4477 21.2818 52 20.7295 52H4.00008C3.44779 52 3.00008 52.4477 3.00008 53V53C3.00008 53.5523 3.44779 54 4.00008 54H20.7295C21.2818 54 21.7295 53.5523 21.7295 53V53Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7295 58C21.7295 57.4477 21.2818 57 20.7295 57H4.00008C3.44779 57 3.00008 57.4477 3.00008 58V58C3.00008 58.5523 3.44779 59 4.00008 59H20.7295C21.2818 59 21.7295 58.5523 21.7295 58V58Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6943 79C26.6943 78.4477 27.1421 78 27.6943 78H81.0355C81.5878 78 82.0355 78.4477 82.0355 79V81C82.0355 81.5523 81.5878 82 81.0355 82H27.6943C27.1421 82 26.6943 81.5523 26.6943 81V79Z",
    fill: "#434343"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 85,
    rx: 2.5,
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.4d15b7645c4fae122a540a7d6d52b6c6.svg";
export { ForwardRef as ReactComponent };